import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import FrameResult from '~/src/features/payments-abn/components/PaymentFrame/FrameResult';
import {
    selectCardPaySum,
} from '~/src/features/payments-abn/components/SeasonTicketPayment/store/selectors/selectPaymentSum';
import { EPaymentTypeIds, setPaymentResult } from '~/src/features/payments-abn/store/actionCreators';
import { checkPaymentStatus } from '~/src/features/payments-abn/store/actions';
import { TState } from '~/src/store';

import { ActionSectionTitle, ActionSectionWrapper } from '~/src/features/payments-abn/styled';
import * as ST from './styled';

export type TPaymentFrameProps = {
    isOtherPaymentsAvailable?: boolean,
}

// TODO PaymentFrame - нужно перенести в попап, для того чтобы можно было его изолировать на уровне компонента оплаты картой
const PaymentFrame = (
    {
        isOtherPaymentsAvailable = true,
    }: TPaymentFrameProps,
): JSX.Element => {
    const dispatch = useDispatch();

    const {
        auth: { isAuth },
        payment: { isSaveCard, paymentTypeId, result },
        seasonTicketPayment: { seasonTicket, bonusesInfo: { amount } },
    } = useSelector((state: TState) => state);

    const cardPaymentSum = useSelector(selectCardPaySum);

    const { query: { s: queryPaySum, transaction } } = useRouter<string>();

    const { paySum = 0 } = seasonTicket || {};

    const goBackHandler = useCallback(() => {
        dispatch(setPaymentResult({ ...result, frameUrl: '', email: '' }));
    }, [dispatch, result]);

    const parseResponse = useCallback((data: Record<string, string>) => {
        const order = data.order_number || data.billing_transaction_id;

        dispatch(checkPaymentStatus(order, transaction, queryPaySum));
    }, [dispatch, queryPaySum, transaction]);

    const isShowHintOnDefaultPayment = isAuth && paymentTypeId === EPaymentTypeIds.DEFAULT && !cardPaymentSum;

    const isShowHintOnSeasonTicketPayment = isAuth && paymentTypeId === EPaymentTypeIds.WHOLESALE && (Math.ceil(paySum) === amount) && isSaveCard;

    return (
        <ActionSectionWrapper>
            <ActionSectionTitle>
                Добавьте карту
                <ST.Subtitle>
                    Введите данные карты, с которой хотите оплачивать услуги. {isOtherPaymentsAvailable && !isShowHintOnSeasonTicketPayment && (
                        <>Если передумали, можно <span onClick={goBackHandler}>использовать другой способ оплаты</span>.</>
                    )}
                </ST.Subtitle>
            </ActionSectionTitle>
            <ST.Content>
                {result?.frameUrl
                    ? <FrameResult url={result.frameUrl} onResponse={parseResponse}/>
                    : null
                }
                {(isShowHintOnDefaultPayment || isShowHintOnSeasonTicketPayment) && (
                    <ST.FrameHint>Для проверки карты мы спишем с нее 1 рубль. После&nbsp;успешной проверки мы перечислим его обратно.</ST.FrameHint>
                )}
            </ST.Content>
        </ActionSectionWrapper>
    );
};

export default PaymentFrame;
